<template>
	<div class="search-brand">
		<div
			v-for="(item, itemIndex) in getTargetBrand"
			:key="itemIndex"
			class="search-brand__wrapper"
			ref="brandSelectorList"
		>
			<BrandSelector
				:itemIndex="itemIndex"
				:brandNames="targetBrand[itemIndex].brandTitle"
				@change="getBrand($event, itemIndex)"
			/>
			<button
				v-if="getTargetBrand.length > 1 && !disabled"
				@click="removeTarget(itemIndex)"
				class="search-brand__remove"
				type="button"
			>
				<i class="fa fas fa-minus" />
			</button>
		</div>

		<div class="search-brand__button-wrapper">
			<button
				v-if="getTargetBrand.length < 4 && !disabled"
				@click="addTarget"
				class="search-brand__add"
				type="button"
			>
				<i class="fa fas fa-plus" />
			</button>
		</div>
	</div>
</template>
<script>
	import BrandSelector from '@/components/common/BrandSelector';

	export default {
		name: 'BrandSelectors',
		props: {
			disabled: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				targetBrand: [
					{ brandTitle: null, showSearchBrand: false, idBrand: null },
				],
			};
		},
		computed: {
			getTargetBrand() {
				return this.targetBrand;
			},
		},
		components: {
			BrandSelector,
		},
		methods: {
			getBrand(brand, index) {
				if (brand) {
					this.targetBrand[index].showSearchBrand = false;
					this.targetBrand[index].idBrand = brand.idBrand;
					this.targetBrand[index].brandTitle =
						this.getBrandLabel(brand);
				} else {
					this.targetBrand[index].showSearchBrand = false;
					this.targetBrand[index].idBrand = null;
					this.targetBrand[index].brandTitle = null;
				}
				this.emitEvent();
			},
			getBrandLabel(brand) {
				if (brand) {
					const brandName = brand.isDisplay
						? `[${brand.idBrand}] ${brand.brandTitle}`
						: `[${brand.idBrand}][미전시] ${brand.brandTitle}`;
					return brandName;
				}
			},
			emitEvent() {
				this.$emit('change', this.getTargetBrand);
			},
			addTarget() {
				this.targetBrand.push({
					brandTitle: null,
					showSearchBrand: false,
					idBrand: null,
				});
			},
			removeTarget(index) {
				this.targetBrand.splice(index, 1);
				this.emitEvent();
			},
			setList(list) {
				this.targetBrand = [...list];
				this.targetBrand.forEach(item => {
					item.brandTitle = `[${item.idBrand}] ${item.brandTitle}`;
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	div {
		.search-brand {
			position: relative;
			display: inline-block;
			font-size: 0;
		}
		.search-brand__wrapper {
			margin-bottom: 10px;
		}

		.search-brand__button-wrapper {
			text-align: center;
			padding: 1em 0 0 0;
		}

		.search-brand__add {
			background: $btn-blue;
			width: 21px;
			height: 21px;
			border-radius: 50%;
			color: #fff;
		}

		.search-brand__remove {
			@extend .search-brand__add;
			background: #ff3860;
			font-size: 0.75rem;
		}
	}
</style>
